import { Observable } from 'rxjs';

import { JobOffer } from 'job/job-offer';
import { ObserveJobOffersByOwnerIdAndOrganizationModuleIdQuery } from 'job/query/observe-job-offers-by-owner-id-and-organization-module-id.query';

export abstract class JobOfferRepositoryPort {
	public abstract observeJobOffersByOwnerIdAndOrganizationModuleId(
		query: ObserveJobOffersByOwnerIdAndOrganizationModuleIdQuery
	): Observable<JobOffer[]>;

	public abstract saveJobOffers(entities: JobOffer[]): Promise<void>;

	public abstract observeJobOffersByIds(ids: string[]): Observable<JobOffer[]>;

	public abstract observeJobOfferById(id: string): Observable<JobOffer>;
}
